import React, { FC } from 'react'
import { Column, Row } from 'react-table'
import Table from '../../components/Table';
import { Grid } from '@material-ui/core';
import { DeviceEvent, DeviceLogData } from '../../api/mobilbase/models';

interface DeviceLogTableProps {
  data: DeviceLogData;
  isPending: boolean;
  setRun: (value: boolean) => void;
}

const DeviceLogTable: FC<DeviceLogTableProps> = ({ data, isPending, setRun }) => {
  const columns: Column<DeviceEvent>[] = React.useMemo(
    () => [
      { Header: 'Tid', id: "0", accessor: 'time',
        sortType: (rowA: Row<DeviceEvent>, rowB: Row<DeviceEvent>) => {
          const a = rowA.values.time.split(/-|:| /);
          const b = rowB.values.time.split(/-|:| /);
          return ((a[2] + a[1] + a[0] + a[3] + a[4] + a[5]) < (b[2] + b[1] + b[0] + b[3] + b[4] + b[5])) ? -1 : 1
        }
      },
      { Header: 'Hændelse', id: "1", accessor: 'eventType' },
      { Header: 'Enhed', id: "2", accessor: 'device' },
      { Header: 'Tekst', id: "3", accessor: 'text' }
    ],
    []
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Table<DeviceEvent> columns={columns} data={data.events} initialState={undefined} clickEvent={() => { }} update={() => { setRun(true) }} pending={isPending} text={""} />
      </Grid>
    </Grid>
  );
};

export default DeviceLogTable;